import React, { useState } from "react";

import CheckWithDate from "../CheckWithDate";
import { Box, Modal } from "@mui/material";
import ViewGeneralLiability from "../forms/ViewGeneralLiability";
import ViewButtonSmall from "../Buttons/ViewButtonSmall";

function FormLine3Mobile(props) {
  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const [showViewModal, setShowViewModal] = useState(false);

  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  return (
    <div
      className={
        props.color === "1"
          ? "formLineMobile2 light-grey-form"
          : "formLineMobile2 grey-form"
      }
    >
      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <ViewGeneralLiability
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
            {...props}
          />
        </Box>
      </Modal>
      <div className="formLineBlock1-mobile">{props.title}</div>
      <div className="formLineBlock2-mobile">
        {props.signed !== true || props.signed === undefined ? (
          <CheckWithDate checked={false} content="Not signed " />
        ) : (
          <CheckWithDate checked={true} content={props.date} />
        )}
      </div>
      <div className="formLineBlock3-mobile">
        {props.signed ? (
          <ViewButtonSmall handleOpen={openViewModal} {...props} />
        ) : (
          ""
        )}

        {/* <DownloadButton2 /> */}

        {/* <CheckButton />
        <PrintButton />
        <MailButton /> */}
      </div>
    </div>
  );
}

export default FormLine3Mobile;
